import React from 'react';
import './NumberInput.scss';
import { Icon } from 'antd';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';

interface IProps {
  ratio?: number;
  isPriceItem?: boolean;
  value: number;
  isIncrementDisabled?: boolean;
  onChange: (value: number) => void;
}

class NumberInput extends React.PureComponent<IProps> {
  public static defaultProps: Partial<IProps> = {
    ratio: 1,
    isPriceItem: false,
    value: 0,
    isIncrementDisabled: false,
  };

  private interval: any;
  
  startIncrementInterval = () => {
    this.increment();
    this.interval = setInterval(() => this.increment(), 250);
  }

  startDecrementInterval = () => {
    this.decrement();
    this.interval = setInterval(() => this.decrement(), 250);
  }

  stopChangeInterval = () => {
    clearInterval(this.interval);
  }

  increment = () => {
    const { value, ratio, isIncrementDisabled, onChange } = this.props;

    if (!isIncrementDisabled) {
      onChange(value + ratio)
    }
  };

  decrement = () => {
    const { value, ratio, onChange } = this.props;

    if(value > 0) {
      onChange(value - ratio)
    }
  };

  render() {
    const { value, isIncrementDisabled, isPriceItem } = this.props;
    const incrementStyle = isIncrementDisabled ? 'disabled' : '';
    const decrementStyle = value <= 0 ? 'disabled' : '';

    return (
      <div className='number-input'>
        { isPriceItem ?
          <PriceItem style='value' price={ value } decimals={ 2 } /> :
          <span className='value'>{ value }</span>
        }
        <div className='icon-container'>
          <button 
            onMouseDown={ this.startIncrementInterval }
            onMouseUp={ this.stopChangeInterval }
            onMouseLeave={ this.stopChangeInterval }
            >
            <Icon 
              type='caret-up'
              className={ incrementStyle }
          />
          </button>
          <button 
            onMouseDown={ this.startDecrementInterval }
            onMouseUp={ this.stopChangeInterval }   
            onMouseLeave={ this.stopChangeInterval }
            >
            <Icon 
              type='caret-down' 
              className={ decrementStyle }
            />
          </button>
        </div>
      </div>
    );
  }
}

export default NumberInput;


// WEBPACK FOOTER //
// ./src/components/Shared/NumberInput/NumberInput.tsx